export default "__VITE_ASSET__BcKA1F4z__"